export default __webpack_public_path__ + "static/media/gw.8b5feec7.svg";